import { Space } from "antd";
import * as Common from "../commons/common";
import * as Utils from "../utils/utils";
import dayjs from "dayjs";
import CustomDatePicker from "./CustomDatePicker";

function SearchDate({
    startDate,
    endDate,
    onSearch,
    picker,
    format,
}: {
    startDate?: String;
    endDate?: String;
    onSearch: (type: string, value: string) => void;
    picker?: "time" | "date" | "week" | "month" | "quarter" | "year";
    format?: string;
}) {
    return (
        <div>
            <Space size={8}>
                <CustomDatePicker
                    placeholder="00/00/00"
                    picker={picker ? picker : "date"}
                    format={format ? format : "YYYY-MM-DD"}
                    value={startDate !== undefined ? dayjs(startDate.valueOf()) : undefined}
                    onChange={(value) =>
                        onSearch("startDate", Utils.utcToLocalTime(String(value).valueOf(), format ? format : Common.FORMAT_DATE_TIME))
                    }
                    allowClear={false}
                />
                <span>~</span>
                <CustomDatePicker
                    placeholder="00/00/00"
                    picker={picker ? picker : "date"}
                    format={format ? format : "YYYY-MM-DD"}
                    value={endDate !== undefined ? dayjs(endDate.valueOf()) : undefined}
                    onChange={(value) =>
                        onSearch("endDate", Utils.utcToLocalTime(String(value).valueOf(), format ? format : Common.FORMAT_DATE_TIME))
                    }
                    allowClear={false}
                />
            </Space>
        </div>
    );
}

export default SearchDate;
